<template>
  <div>
    <b-modal
      id="missingEntriesModal"
      size="xl"
      content-class="menu-bg-blue-transparent-modal"
      title="Daily Productivity Report Missing Entries"
      hide-footer
     
      scrollable
      @show="initMissingEntriesModal()"
    >
      <vue-bootstrap4-table
        :rows="missingRows"
        :columns="missingColumns"
        :config="config"
        :classes="classes"
      >
        <template slot="Vehicles" slot-scope="props">
          {{ props.cell_value.join(', ') }}
        </template>
      </vue-bootstrap4-table>
    </b-modal>
  </div> 
</template>

<script>
import VueBootstrap4Table from 'vue-bootstrap4-table'

export default {
  name: 'MMP_DPR_MissingEntriesModal',
  components: {
    VueBootstrap4Table
  },
  props: ['entries'],
  data() {
    return {
      missingColumns: [
        {
          label: 'Jday',
          name: 'Jday',
          sort: false
        },
        {
          label: 'Missing Entries',
          name: 'count',
          sort: true
        },
        {
          label: 'Vehicles',
          name: 'Vehicles',
          sort: false
        }
      ],
      missingRows: [],
      config: {
        checkbox_rows: false,
        rows_selectable: false,
        card_mode: false,
        highlight_row_hover_color: '#4a4a4a',
        per_page: 10,
        global_search: {
          visibility: false
        },
        show_refresh_button: false,
        show_reset_button: false
      },
      classes: {
        table: {
          'menu-bg-blue-transparent-modal': true
        }
      }
    }
  },
  methods: {
    initMissingEntriesModal() {
      this.missingRows = []
      for (var jday in this.entries) {
        this.missingRows.push({
          Jday: jday,
          count: this.entries[jday].length,
          Vehicles: this.entries[jday]
        })
      }
    }
  }
}
</script>
